class ProductDescription extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(this.els.trigger.element, 'click', this.handleTrigger)
  }

  handleTrigger () {
    const accordionEl = this.externalEls.accordion.element

    const contentEl = accordionEl.querySelector(
      '[data-accordion-group-el="content"]',
    )

    accordionEl.style.setProperty('--Max_Height', `${contentEl.offsetHeight}px`)
    accordionEl.setAttribute('aria-expanded', true)

    accordionEl.scrollIntoView()
  }
}

if (!customElements.get('product-description')) {
  customElements.define('product-description', ProductDescription)
}
